import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { IoArrowBackCircle } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { Pagination } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const QuizResults = () => {
    const [quizResults, setQuizResults] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);
            console.log('Stored User:', parsedUser);
        }
    }, []);

    // useEffect(() => {
    //     if (user && user.id) {
    //         axios.get(`https://rvapi.emedha.in/pages/api/get-fastest-answers?user_id=${user.id}`)
    //             .then(response => {
    //                 setQuizResults(response.data.data);
    //             })
    //             .catch(error => {
    //                 console.error('Failed to load fastest answers:', error);
    //             });
    //     }
    // }, [user]);
    useEffect(() => {
        if (user && user.id) {
            const fetchData = () => {
                axios.get(`https://rvapi.emedha.in/pages/api/get-fastest-answers?user_id=${user.id}`)
                    .then(response => {
                        setQuizResults(response.data.data);
                    })
                    .catch(error => {
                        console.error('Failed to load fastest answers:', error);
                    });
            };
            fetchData(); // Initial fetch immediately
            const intervalId = setInterval(fetchData, 500); // Repeat every 5 milli second
            return () => clearInterval(intervalId); // Cleanup
        }
    }, [user]);


    const [events, setEvents] = useState([]);
    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);
        } else {
            console.log('No user data found in session storage');
        }
    }, []);
    useEffect(() => {
        if (user && user.id) {
            fetchEvents();
        } else {
            console.log('User is missing or incomplete');
        }
    }, [user]);

    const fetchEvents = async () => {
        if (!user || !user.id) {
            console.error('User ID is missing');
            return;
        }
        try {
            const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
            setEvents(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            console.log(false);
        }
    };

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };
    const indexOfLastResult = currentPage * itemsPerPage;
    const indexOfFirstResult = indexOfLastResult - itemsPerPage;
    const currentResults = quizResults.slice(indexOfFirstResult, indexOfLastResult);
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const formatTime = (seconds) => {
        const s = parseFloat(seconds);
        if (s < 60) {
            return s.toFixed(2).padStart(5, '0') + ' sec';
        } else {
            const minutes = Math.floor(s / 60);
            const remaining = s % 60;
            return `${String(minutes).padStart(2, '0')}.${remaining.toFixed(2).padStart(5, '0')} min`;
        }
    };

    const groupedResults = quizResults.reduce((acc, item) => {
        const key = item.email || item.name;
        if (!acc[key]) { acc[key] = []; }
        acc[key].push(item);
        return acc;
    }, {});


    return (
        <div>
            <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', }}>
                <img src={events.find((event) => event.flag === 1)?.file || ''} alt="Logo" style={{ width: '100px' }} />
                <div style={{ flexGrow: 1, textAlign: 'center' }}>
                    <h2 style={{ color: '#333', fontSize: '24px', fontWeight: '600', }} >
                        {events && events.length > 0 ? events[0].name : 'No event available'}
                    </h2>
                </div>
            </div>

            <div className='mt-2' style={{ border: 'solid 2px black', borderRadius: '20px', padding: '10px' }}>
                <h1 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <IoArrowBackCircle onClick={handleBack} style={{ cursor: 'pointer' }} />
                    <span style={{ flex: 1, textAlign: 'center' }}>Quiz Results</span>
                </h1>
            </div>

            <div className="table-responsive shadow-sm bg-white p-3 rounded">
                <table className="table table-bordered table-hover align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Mobile</th>
                            <th>Question</th>
                            <th>Correct Answer</th>
                            <th>Time Taken</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(groupedResults).map(([userKey, results], groupIndex) => (
                            <React.Fragment key={userKey}>
                                <tr className="table-primary">
                                    <td colSpan="7" style={{ fontWeight: 'bold' }}>
                                        {results[0].name} ({results[0].email}) — Total Marks: {results[0].total_marks ?? 'N/A'}
                                    </td>
                                </tr>
                                {results.map((result, index) => (
                                    <tr key={result.id}>
                                        <td>{index + 1}</td>
                                        <td>{result.name}</td>
                                        <td>{result.email}</td>
                                        <td>{result.mobile}</td>
                                        <td>{result.question}</td>
                                        <td>{result.is_correct ? '✓' : '✗'}</td>
                                        <td className="text-nowrap">{formatTime(result.time_taken)}</td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                    </tbody>

                </table>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <Pagination>
                    <Pagination.Prev onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)} />
                    {[...Array(Math.ceil(quizResults.length / itemsPerPage))].map((_, index) => (
                        <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>{index + 1}</Pagination.Item>
                    ))}
                    <Pagination.Next onClick={() => currentPage < Math.ceil(quizResults.length / itemsPerPage) && handlePageChange(currentPage + 1)} />
                </Pagination>
            </div>
            <footer style={{ position: 'fixed', left: '0', bottom: '0', width: '100%', padding: '20px 0', backgroundColor: '#333', color: 'white', textAlign: 'center', fontSize: '14px', zIndex: '1000', }}>
                <p>© 2025 E-medha technologies. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default QuizResults;
